import { render, staticRenderFns } from "./SinglePurchase.vue?vue&type=template&id=2567d21f&"
import script from "./SinglePurchase.vue?vue&type=script&lang=js&"
export * from "./SinglePurchase.vue?vue&type=script&lang=js&"
import style0 from "./SinglePurchase.vue?vue&type=style&index=0&id=2567d21f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports